import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

export const variantMapping = {
  'earnings-management': {
    border: `1px solid ${COLOR.borderDropdown}`,
    width: '208px',
    height: '40px',
    padding: '8px',
    widthPapers: '208px',
    gap: '8px',
  },
  'speed-management': {
    width: '105px',
    padding: '4px',
    widthPapers: '208px',
    gap: '4px',
  },
  'format-audio': {
    width: '100px',
    padding: '4px',
    widthPapers: '100px',
    gap: '4px',
    marginTopPopover: '6px',
  },
  'config-voice': {
    width: 'max-content',
    padding: '4px',
    widthPapers: '273px',
    gap: '4px',
    paddingPapers: '12px 16px',
    paddingListMenuItem: '0px',
    paddingListMenuItemHover: '12px 16px 0px 16px',
    marginTopPopover: '6px',
    maxHeightList: '200px',
    boxShadown: 'none',
    backgroundColor: `${COLOR.backgroundLinearProgress}`,
  },
  'language-voice': {
    border: `1px solid ${COLOR.borderDropdown}`,
    width: '168px',
    height: '40px',
    padding: '8px 12px',
    widthPapers: '230px',
    gap: '8px',
    maxHeightList: '180px',
    marginTopPopover: '14px',
  },
  'language-voice-mobile': {
    border: `1px solid ${COLOR.borderDropdown}`,
    width: '100%',
    height: '40px',
    padding: '8px 12px',
    widthPapers: '100%',
    gap: '8px',
    maxHeightList: '180px',
    marginTopPopover: '8px',
  },
  'block-status': {
    border: `1px solid ${COLOR.borderDropdown}`,
    width: 'fit-content',
    height: '32px',
    itemHeight: '40px',
    padding: '4px 8px 4px 12px',
    widthPapers: 'fit-content',
    gap: '8px',
    maxHeightList: '240px',
    marginTopPopover: '14px',
  },
  'form-select': {
    border: `1px solid ${COLOR.borderButtonCorlor}`,
    width: '100%',
    height: '40px',
    padding: '8px 12px',
    widthPapers: '100%',
    gap: '8px',
    maxHeightList: '216px',
    marginTopPopover: '8px',
    paddingListMenuItem: '8px',
    paddingListMenuItemHover: '8px',
  },
  'form-select-light': {
    border: `0.5px solid ${COLOR.indigo[16]}`,
    width: '100%',
    height: '40px',
    padding: '8px 12px',
    widthPapers: '100%',
    gap: '8px',
    maxHeightList: '216px',
    marginTopPopover: '8px',
    paddingListMenuItem: '8px',
    paddingListMenuItemHover: '8px',
  },
  'form-select-error': {
    border: `1px solid ${COLOR.functionalRed.default}`,
    width: '100%',
    height: '40px',
    padding: '8px 12px',
    widthPapers: '100%',
    gap: '8px',
    maxHeightList: '216px',
    marginTopPopover: '8px',
    paddingListMenuItem: '8px',
    paddingListMenuItemHover: '8px',
  },
  'block-voice': {
    border: `1px solid ${COLOR.borderDropdown}`,
    width: 'fit-content',
    height: '32px',
    itemHeight: '40px',
    padding: '4px',
    widthPapers: 'fit-content',
    gap: '8px',
    maxHeightList: '240px',
    marginTopPopover: '14px',
  },
  'app-duration': {
    border: `1px solid ${COLOR.indigo[32]}`,
    width: '100%',
    height: '40px',
    itemHeight: '40px',
    padding: '8px',
    widthPapers: '270px',
    gap: '8px',
    maxHeightList: '256px',
    marginTopPopover: '6px',
  },
  'api-request-status': {
    border: `1px solid ${TRANSPARENT_COLOR.borderGray}`,
    width: '100%',
    height: '40px',
    itemHeight: '40px',
    padding: '8px',
    widthPapers: '180px',
    gap: '8px',
    maxHeightList: '256px',
    marginTopPopover: '6px',
  },
};
